import React, { useState, useEffect } from "react";
import "./alert.css";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  MenuItem,
  Menu,
  Skeleton,
  Tooltip,
} from "@mui/material";
import Swal from "sweetalert2";
import instance from "../../ApiInstance/Inetrceptor";
import AddNew from "../Alerts/HandlingAddtracks";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import StyledTableCell from "../../Tabletheme/Customtableheader";
import CustomTheme from "../../Customtheme/Themes"
import "react-phone-number-input/style.css";

const HandlingTracks = () => {
  const { drawerWidth, isXs, isSm, isMd, isLg, isXl } = CustomTheme();
  const [selectedItems, setSelectedItems] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [showmoreLoader, setShowmoreLoader] = useState(false);
  const [sortField, setSortField] = useState("alert_handling_track_name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [pageNo, setPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [handlingdata, setHandlingdata] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [isAddSectionOpen, setIsAddSectionOpen] = useState(false);
  const [isEditSectionOpen, setIsEditSectionOpen] = useState(false);
  const [handlinginfo, setHandlinginfo] = useState({});
  const open = Boolean(anchorEl);
  const handleSort = (field) => {
    const order = field === sortField && sortOrder === "asc" ? "desc" : "asc";
    console.log("field", order);
    setSortField(field);
    setSortOrder(order);
    GetHandlingData(pageNo, field, order);
  };
  const GetHandlingData = (
    pageNumber = pageNo,
    field = sortField,
    order = sortOrder,
    searchText
  ) => {
    const body = {
      id: "",
      searchtext: searchText ?? "",
      pageno: pageNumber ?? 1,
      pagesize: 10,
      sortby: field ?? "",
      sortord: order ?? "",
    };
    instance
      .post("api/v1/Master/AlertHandlingTrack/Get", body)
      .then((res) => {
        const newData = res?.data?.Value ?? [];
        setTotalRecords(res?.data?.Records);
        if (pageNumber === 1) {
          setHandlingdata(res?.data?.Value ?? []);
        } else {
          setHandlingdata((prevData) => [...prevData, ...newData]);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };

  const handleButtonClick = () => {
    setIsDrawerOpen(true);
    setIsAddSectionOpen(true);
    setIsEditSectionOpen(false);
  };

  const deleteMaintainData = (entityId) => {
    instance
      .delete(`api/v1/Master/AlertHandlingTrack/Delete/${entityId}`)
      .then((res) => {
        const ResultData = res?.data?.ResultMessage ?? [];
        if (ResultData === "Deletion Success") {
          setHandlingdata((prevData) => {
            return prevData.filter(row => row.alert_handling_track_id !== entityId);
          });
           GetHandlingData();
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: ResultData,
            customClass: {
              confirmButton: "custom-confirm-button-class",
            },
            buttonsStyling: false,
            showCancelButton: false,
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: ResultData,
            customClass: {
              confirmButton: "custom-cancle-button-class",
            },
            buttonsStyling: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        console.log("newData12", err);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          customClass: {
            confirmButton: "custom-cancle-button-class",
          },
          buttonsStyling: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  const handleEdit = (event, row, index) => {
    if (event.target.innerText === "Edit") {
      setHandlinginfo(row);
      setIsDrawerOpen(true);
      setIsAddSectionOpen(false);
      setIsEditSectionOpen(true);
      setAnchorEl(null);
      setSelectedRowIndex(null);
    } else if (event.target.innerText === "Delete") {
      Swal.fire({
        icon: "question",
        text: "Are you sure you want to delete",

        customClass: {
          confirmButton: "custom-confirm-button-class",
          cancelButton: "custom-cancle-button-class",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        allowOutsideClick: false,
        reverseButtons: true,
      }).then((responce) => {
        if (responce?.isConfirmed) {
          deleteMaintainData(row?.alert_handling_track_id);
        } else {
        }
      });
    }
    setAnchorEl(null);
    setSelectedRowIndex(null);
  };
  const handleEditClick = (event, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowIndex(index);
  };
  useEffect(() => {
    GetHandlingData(pageNo, sortField, sortOrder);
  }, [sortField, sortOrder]);

  return (
    <>
      <div className="parentAlert_div">
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="mb-4"
        >
          <p className="headingAlert_font">Alert Handling Tracks</p>
          <p className="headAlert_div"></p>
        </div>

        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item xl={2.3} lg={3.5} md={6} sm={12} xs={12}>
            <Button
              variant="contained"
              className="button_headerAlert"
              onClick={handleButtonClick}
              color="secondary"
              sx={{
                width: "100%",
              }}
            >
              Add Alert Handling Track <AddIcon />
            </Button>
          </Grid>
          <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
            <div className="search-sectionAlert d-flex">
              <div style={{ width: "10%" }}>
                <img src="assets/Images/searchicon.svg" alt="Search Icon" />
              </div>
              <div className="search-inputAlert">
                <input
                  onKeyUp={(event) => {
                    if (event.key === "Enter") {
                      GetHandlingData(
                        1,
                        sortField,
                        sortOrder,
                        event.target.value
                      );
                    }
                  }}
                  onChange={(event) => {
                    setSearchText(event.target.value);
                    if (event.target.value.length === 0) {
                      GetHandlingData(1, sortField, sortOrder, "");
                    }
                  }}
                  type="text"
                  placeholder="Search / Filter"
                />
              </div>
            </div>
          </Grid>
        </Grid>
        <AddNew
          setIsDrawerOpen={setIsDrawerOpen}
          isDrawerOpen={isDrawerOpen}
          isAddSectionOpen={isAddSectionOpen}
          isEditSectionOpen={isEditSectionOpen}
          handlinginfo={handlinginfo}
          GetHandlingData={GetHandlingData}
        />

        <TableContainer sx={{ marginTop: 5, maxHeight: 600 }} component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow className="Table_rowAlert">
                <StyledTableCell
                  onClick={() => handleSort("alert_handling_track_name")}
                >
                  Track Name
                  {sortField === "alert_handling_track_name" && (
                    <>
                      {sortOrder === "asc" ? (
                        <img
                          src="assets/Images/Ascending.svg"
                          alt="Ascending"
                          style={{ width: "13px", marginLeft: "5px" }}
                        />
                      ) : (
                        <img
                          src="assets/Images/descending.svg"
                          alt="Descending"
                          style={{ width: "13px", marginLeft: "5px" }}
                        />
                      )}
                    </>
                  )}
                </StyledTableCell>
                <StyledTableCell>Description</StyledTableCell>
                <StyledTableCell>Interval</StyledTableCell>
                <StyledTableCell>Escalation 0</StyledTableCell>
                <StyledTableCell>Escalation 1</StyledTableCell>
                <StyledTableCell>Escalation 2</StyledTableCell>
                <StyledTableCell />
              </TableRow>
            </TableHead>
            {loader ? (
              <>
                {new Array(8).fill(3).map((element, index) => {
                  return (
                    <TableRow key={index}>
                      {new Array(7).fill(1).map((element, index) => {
                        return (
                          <TableCell align="center" key={index}>
                            <Skeleton
                              variant="rounded"
                              width={"100%"}
                              height={60}
                            />
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </>
            ) : (
              <>
                {handlingdata.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      <p>No Data Found</p>
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableBody>
                    {handlingdata.map((row, index) => (
                      <TableRow key={index}>
                        {/* key={row.id} */}
                        <TableCell
                          style={{ minWidth: "10rem", maxWidth: "10rem" }}
                        >
                          {row.alert_handling_track_name}
                        </TableCell>
                        <TableCell
                          style={{ minWidth: "20rem", maxWidth: "20rem",
                          overflow: "hidden",
                          textOverflow: "ellipsis", }}
                        >
                          <Tooltip
                            title={row.alert_handling_track_desc}
                            arrow
                            placement="top"
                          >
                             {row?.alert_handling_track_desc?.length >150
                                ? row.alert_handling_track_desc.substring(0, 150) +
                                  "..."
                                : row.alert_handling_track_desc}
                              </Tooltip>
                        </TableCell>
                        <TableCell
                          style={{ minWidth: "3rem", maxWidth: "3rem" }}
                        >
                          {row.notification_interval}
                        </TableCell>
                        <TableCell
                          style={{
                            minWidth: "15rem",
                            maxWidth: "15rem",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <Tooltip
                            title={row.escalation_00_emails}
                            arrow
                            placement="top"
                          >
                            <span>
                              <b>Email:</b>
                              {row?.escalation_00_emails?.length > 25
                                ? row.escalation_00_emails.substring(0, 25) +
                                  "..."
                                : row.escalation_00_emails}
                            </span>
                          </Tooltip>
                          <br />
                          <span>
                            <b>SMS:</b>
                            {row.escalation_00_sms}
                          </span>
                        </TableCell>
                        <TableCell
                          style={{
                            minWidth: "15rem",
                            maxWidth: "15rem",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <Tooltip
                            title={row.escalation_01_emails}
                            arrow
                            placement="top"
                          >
                            <span>
                              <b>Email:</b>
                              {row?.escalation_01_emails?.length > 25
                                ? row.escalation_01_emails.substring(0, 25) +
                                  "..."
                                : row.escalation_01_emails}
                            </span>
                          </Tooltip>
                          <br />
                          <span>
                            <b>SMS:</b>
                            {row.escalation_01_sms}
                          </span>
                        </TableCell>
                        <TableCell
                          style={{
                            minWidth: "15rem",
                            maxWidth: "15rem",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <Tooltip
                            title={row.escalation_02_emails}
                            arrow
                            placement="top"
                          >
                            <span>
                              <b>Email:</b>
                              {row?.escalation_02_emails?.length > 25
                                ? row.escalation_02_emails.substring(0, 25) +
                                  "..."
                                : row.escalation_02_emails}
                            </span>
                          </Tooltip>
                          <br />
                          <span>
                            <b>SMS:</b>
                            {row.escalation_02_sms}
                          </span>
                        </TableCell>
                        <TableCell>
                          <div
                            style={{
                              textAlign: "center",
                              minWidth: "2rem",
                              maxWidth: "2rem",
                            }}
                          >
                            <MoreVertIcon
                              onClick={(event) => handleEditClick(event, index)}
                              id="basic-button"
                              aria-controls={
                                Boolean(anchorEl)
                                  ? `basic-menu-${index}`
                                  : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={
                                Boolean(anchorEl) ? "true" : undefined
                              }
                            />

                            <Menu
                              id={`basic-menu-${index}`}
                              anchorEl={anchorEl}
                              open={
                                selectedRowIndex !== null &&
                                selectedRowIndex === index
                              }
                              onClose={handleEdit}
                              MenuListProps={{
                                "aria-labelledby": `basic-button-${index}`,
                              }}
                            >
                              <MenuItem
                                onClick={(event) => {
                                  handleEdit(event, row, index);
                                }}
                              >
                                Edit
                              </MenuItem>
                              <MenuItem
                                onClick={(event) => {
                                  handleEdit(event, row, index);
                                }}
                              >
                                Delete
                              </MenuItem>
                            </Menu>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}{" "}
              </>
            )}
          </Table>
        </TableContainer>

        <Grid item xs={12} className="mt-4" sx={{ textAlign: "center" }}>
          {totalRecords > handlingdata.length && handlingdata.length > 0 && (
            <Button
              id="back-button"
              variant="contained"
              color="secondary"
              sx={{ textTransform: "none" }}
              onClick={() => {
                setShowmoreLoader(true);
                setPageNo((prev) => prev + 1);
                GetHandlingData(pageNo + 1, sortField, sortOrder);
              }}
            >
              {showmoreLoader ? "loading" : "Show More"}
            </Button>
          )}
        </Grid>
      </div>
    </>
  );
};

export default HandlingTracks;
